export const initialState = {
  base: {
    email: '',
    firstName: '',
    icon: '',
    id: '',
    isAdmin: false,
    lastName: '',
    phoneNumber: '',
  },
  nextRouteLocation: '',
  ui: {
    hasCheckedSession: false,
    isFetchingSession: false,
    isFetchingUserProfile: false,
  },
};

export const permissionsSchema = {
  additionalProperties: false,
  properties: {
    organizationManagers: {
      default: [],
      type: ['array'],
    },
  },
  type: 'object',
};

// user schema validation
export const userSchema = {
  additionalProperties: false,
  properties: {
    email: { type: 'string' },
    firstName: { type: 'string' },
    icon: { type: 'string' },
    id: { type: 'string' },
    isAdmin: { type: 'boolean' },
    lastName: { type: 'string' },
    permissions: { ...permissionsSchema },
    phoneNumber: { type: 'string' },
    wherebyURL: { type: 'string' },
  },
  type: 'object',
};
